// extracted by mini-css-extract-plugin
export default {"caption":"Caption_caption__x0EtQ","body":"Caption_body__zRGvY","currentCaption":"Caption_currentCaption__iyRp-","timestamp":"Caption_timestamp__buKNq"};